let SERVER = ''
let SERVER_V2 = ''
let name = ''

let features = null
name = 'Nông Sản Xuất Khẩu'
switch (window.location.hostname) {
  case 'farmlocal.com':
  case 'localhost':
    SERVER = 'https://farmbook.com/API'
    SERVER_V2 = 'http://localhost:8000/api'

    features = {
      garden: true,
      store: true,
      tracking: true,
      find_land: true
    }
    break
  default:
    SERVER = 'https://api.f2f.com.vn/API'
    SERVER_V2 = 'https://v2.f2f.com.vn/api'

    features = {
      garden: true,
      store: true,
      tracking: true,
      find_land: true
    }
    break
}

let role = {
  admin: 1,
  farmer: 2,
  system_user: 3,
  seller: 4
}
// https://farmbook.com/API/loginZalo
// https://oauth.zaloapp.com/v3/permission?app_id=2313870396196688761&redirect_uri={2}&state={3}

let apiKeyHereMap = '9ComSRXwJ8kxxSa1SMtEkPYCsX--3r2We93Q9rhZHGI'
let siteProductNames = ['Bưởi', 'Cam', 'Quýt']
export default {
  SERVER: SERVER,
  SERVER_V2: SERVER_V2,
  role: role,
  name: name,
  country_code: '+84',
  features: features,
  apiKeyHereMap: apiKeyHereMap,
  siteProductNames: siteProductNames,
  domain: 'nongsanxuatkhau.vn'
}



// WEBPACK FOOTER //
// ./src/helpers/config.js